export const styles = {
    backgrounds: [
        {className: "primary-bg-colour", colour: "#E60000"},
    ],
    text: [
        {className: "primary-text", colour: "#FFFFFF"},
        {className: "secondary-text", colour: "#C10041"},
        {className: "tertiary-text", colour: "#525252"},
    ],
    borders: [],
};

